import React, { Component } from 'react';
import { FormGroup, Input, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';
import { listarOpcionesBaja, registrarBaja } from '../../store/sagas/dealerApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion } from '../../utilitarios/util';
import Spinner from "../reusable/Loader";
import { AuthContext } from "../../store/provider/AuthProvider";

function Step1({ dadComponent }) {
  let { incidentes, selected, text, id, errorValidacopn } = dadComponent.state;
  let { seleccionarOpcion } = dadComponent;

  return (
    <div>
      <div className="card card_container">
        <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
        <div className="m-auto" style={{ maxWidth: 330 }}>
          <p className="paragraph-2 light">¿Por qué deseas eliminar tu cuenta?</p>
          <ul className="select-incidente">
            {incidentes.map((item, index) => {
              return (
                <li key={"ix_" + index}>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      value={item.id}
                      onChange={seleccionarOpcion}
                      checked={item.check}
                      type="radio"
                      id={"radio_" + index}
                      name={"radio_" + index}
                      className="custom-control-input"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor={"radio_" + index}
                    >{item.nombre}</label>
                  </div>
                </li>
              )
            })}


          </ul>
          <div className="text-center mt-5 mobile">
            <button style={{ backgroundColor: c.rojo }} disabled={selected == undefined} className="btn-block" onClick={() => dadComponent.nextStep()}>CONTINUAR</button>
          </div>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button style={{ backgroundColor: c.rojo }} disabled={selected == undefined} className="btn-block" onClick={() => dadComponent.nextStep()}>CONTINUAR</button>
      </div>
    </div>
  )
}

function Step2({ dadComponent, auth }) {
  const { mensaje, finish } = dadComponent.state;
  const { postRegistrarBaja } = dadComponent;

  return (
    <div>
      <div className="card card_container">
        <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
        <div className="empty elminar_cuenta" style={{ maxWidth: 775 }}>
          <p className="paragraph-1 mb-0 text-center">
            {mensaje}<br />¿Estás seguro que deseas eliminar tu cuenta?</p>
        </div>
        <div className="text-center mt-5 mobile">
          <button style={{ backgroundColor: c.rojo }} disabled={finish} onClick={postRegistrarBaja} className="btn-block">CONFIRMADO</button>
          <Link className="link-u mt-3" to="/dashboard" style={{ color: c.rojo }}>Cancelar</Link>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button style={{ backgroundColor: c.rojo }} disabled={finish} onClick={postRegistrarBaja} className="btn-block">CONFIRMADO</button>
        <Link className="link-u mt-4" to="/dashboard" style={{ color: c.rojo }}>Cancelar</Link>
      </div>
    </div>
  )
}

export class EliminarCuenta extends Component {
  static displayName = EliminarCuenta.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      dealer: {},
      loading: true,
      incidentes: [],
      mensaje: "",
      id: 0,
      text: "",
      errorValidacopn: null,
      email: null,
      selected: undefined,
      finish: false
    };
    this.backStep = this.backStep.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.load();
  }

  load = () => {
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({ loading: true, dealer: data.dealer }, () => {
      this.postListarDataOpciones(data.dealer);
    })
  }
  postRegistrarBaja = async (opcion) => {
    this.setState({ loading: true, finish: true })
    registrarBaja(this.state.dealer.correoElectronico, this.state.dealer.codcliente, this.state.incidentes.find(x => x.check).id)
      .then(result => {
        console.log("result====>", result.dto)
        if (result.mo.type == "success") {
          this.setState({
            loading: false
          })
          // this.props.history.push('/')

          const auth = this.context;
          localStorageCustom.prototype.removeToken();
          localStorageCustom.prototype.removeUsuario();
          auth.setuserToken(null);
          auth.setIsLoggedIn(false);
          // history.pushState(null, null, '/');
          window.location.href = "/";


        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false, finish: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Eliminar Cuenta", error.message ?? null);
        });
      });
  }

  postListarDataOpciones = async (dealer) => {
    this.setState({ loading: true })
    listarOpcionesBaja(dealer.correoElectronico)
      .then(result => {
        console.log("result====>", result.dto)
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            incidentes: result.dto.dataBajas.opciones,
            mensaje: result.dto.dataBajas.mensaje
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Eliminar Cuenta", error.message ?? null);
        });
      });
  }
  seleccionarOpcion = async (e) => {
    console.log(e.target.value);
    var value = e.target.value;
    let data = this.state.incidentes;
    for (var i = 0; i <= data.length - 1; i++) {
      data[i].check = (data[i].id == value);
    }
    this.setState({
      incidentes: data,
      selected: data.find(x => x.check)
    })
    console.log(data);
  }
  nextStep() {
    this.setState({ step: this.state.step + 1 })
  }

  backStep() {
    this.setState({ step: this.state.step - 1 })
  }

  renderStep() {
    switch (this.state.step) {
      case 0:
        return <Step1 dadComponent={this} />
      case 1:
        return <Step2 dadComponent={this} />
      default:
        return <Step1 dadComponent={this} />
    }
  }

  render() {
    const { loading, step } = this.state;
    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Eliminar cuenta</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Eliminar cuenta</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile">
            {step != 0 ?
              <a onClick={this.backStep} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a> :
              <Link to='/dashboard' className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link>
            }
            Eliminar cuenta
          </h6>
          {this.renderStep()}
        </Container>
      </div>
    );
  }
}
